import { NavLink, Outlet } from 'react-router-dom'

export function AdminLayout() {
  return (
    <div className="admin-shell">
      <aside className="admin-aside">
        <h2>Administration</h2>
        <nav className="admin-nav">
          <NavLink to="/admin" end>
            Benutzer
          </NavLink>
          <NavLink to="/admin/settings">Einstellungen</NavLink>
          <NavLink to="/admin/system">System</NavLink>
        </nav>
      </aside>
      <section className="admin-main">
        <Outlet />
      </section>
    </div>
  )
}
